import React, { useEffect, useState } from 'react'
import NewWindow from 'react-new-window'
import { DocumentUrlNameDto, isDocumentUrlExists } from 'api/Documents/Types/DocumentUrlNameDto'
import { Modal } from 'components/CustomModal'
import { Spinner } from 'components/Spinner'
import { useApiClient } from 'utils/api/ApiClient'
import { DocumentApiClient } from 'utils/api/documentApi'
import { checkFileTypeByFileName, FileType } from 'utils/check-file-type'

type Props = {
  document: { id: string; name?: string }
  onClose(): void
}

export const DocumentPreviewModal: React.FC<Props> = ({ document, onClose }) => {
  const documentApiClient = useApiClient(DocumentApiClient)
  const [data, setData] = useState<undefined | DocumentUrlNameDto>(undefined)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const url = await documentApiClient.getDocumentUrl(document.id)
        if (isDocumentUrlExists(url)) {
          setData(url)
        }
      } catch (error) {
        console.error(error)
      }

      setIsLoading(false)
    }
    fetchData()
  }, [document.id]) // eslint-disable-line react-hooks/exhaustive-deps

  const tryOpenFile = (url: string) => {
    if (data) {
      window.open(url, '_blank')
    }
    onClose()
  }

  if (isLoading || !data) {
    return <Spinner />
  }

  if (isDocumentUrlExists(data) && checkFileTypeByFileName(data.filename) === FileType.IMAGE) {
    return (
      <NewWindow
        onUnload={() => onClose()}
        copyStyles
        features={{ left: 200, top: 200, width: 800, height: 800 }}
      >
        <img src={data.url} alt='' width='100%' height='auto' />
      </NewWindow>
    )
  }

  return (
    <Modal visible={true} onClose={onClose}>
      {isDocumentUrlExists(data) && (
        <>
          {checkFileTypeByFileName(data.filename) === FileType.IMAGE && (
            <img src={data.url} alt='image' height={500} />
          )}
          {checkFileTypeByFileName(data.filename) === FileType.PDF && tryOpenFile(data.url)}
          {checkFileTypeByFileName(data.filename) === FileType.UNKNOWN && tryOpenFile(data.url)}
        </>
      )}
    </Modal>
  )
}
